/**
 * Format duration from seconds to MM:SS or H:MM:SS format
 * @param seconds Duration in seconds
 * @returns Formatted duration string
 */
export const formatDuration = (seconds: number | undefined | null): string => {
  if (!seconds || seconds <= 0) return '';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Parse duration string (MM:SS or H:MM:SS) to seconds
 * @param duration Duration string in MM:SS or H:MM:SS format
 * @returns Duration in seconds, or undefined if invalid
 */
export const parseDuration = (duration: string | undefined | null): number | undefined => {
  if (!duration) return undefined;

  const parts = duration.split(':').map(p => parseInt(p, 10));

  if (parts.some(isNaN)) return undefined;

  if (parts.length === 2) {
    // MM:SS format
    const [minutes, seconds] = parts;
    return minutes * 60 + seconds;
  } else if (parts.length === 3) {
    // H:MM:SS format
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }

  return undefined;
};
